import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer } from "@blueprintjs/select";
import * as React from "react";

export interface IProvider {
  providerid: number,
  providerName: string,
  phoneNumber: string,
  eligibleToServiceTrip: boolean
}

export const renderProvider: ItemRenderer<IProvider> = (provider, { handleClick, modifiers, query }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }

  const text = `${provider.providerName}`;
  return (
    <MenuItem
      active={modifiers.active}
      disabled={modifiers.disabled}
      key={provider.providerid}
      onClick={handleClick}
      text={highlightText(text, query)}
    />
  );
}

export const filterProvider: ItemPredicate<IProvider> = (query, film, _index, exactMatch) => {
  const normalizedTitle = film.providerName.toLowerCase();
  const normalizedQuery = query.toLowerCase();

  if (exactMatch) {
      return normalizedTitle === normalizedQuery;
  } else {
      return `${normalizedTitle}`.indexOf(normalizedQuery) >= 0;
  }
};

function highlightText(text: string, query: string) {
  let lastIndex = 0;
  const words = query
      .split(/\s+/)
      .filter(word => word.length > 0)
      .map(escapeRegExpChars);
  if (words.length === 0) {
      return [text];
  }
  const regexp = new RegExp(words.join("|"), "gi");
  const tokens: React.ReactNode[] = [];
  while (true) {
      const match = regexp.exec(text);
      if (!match) {
          break;
      }
      const length = match[0].length;
      const before = text.slice(lastIndex, regexp.lastIndex - length);
      if (before.length > 0) {
          tokens.push(before);
      }
      lastIndex = regexp.lastIndex;
      tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
  }
  const rest = text.slice(lastIndex);
  if (rest.length > 0) {
      tokens.push(rest);
  }
  return tokens;
}

function escapeRegExpChars(text: string) {
  return text.replace(/([.*+?^=!:${}()|\]\\])/g, "\\$1");
}

export const ProviderSelectProps = {
  itemPredicate: filterProvider,
  itemRenderer: renderProvider,
};

export function areProviderEqual(providerA: IProvider, providerB: IProvider) {
  // Compare only the titles (ignoring case) just for simplicity.
  return providerA.providerName.toLowerCase() === providerB.providerName.toLowerCase();
}

export function arrayContainsProvider(provider: IProvider[], providerToFind: IProvider): boolean {
  return provider.some((p: IProvider) => p.providerName === providerToFind.providerName);
}

export function addProviderToArray(provider: IProvider[], providerToAdd: IProvider) {
  return [...provider, providerToAdd];
}
